<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
    <v-card>
      <validation-observer ref="observer" v-slot="{ errors }">
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title v-text="altTitle || title" />
          <v-spacer />
          <v-toolbar-items v-if="mode === 'form'">
            <v-btn
              dark
              text
              @click="save()"
              :loading="loading && !(error && error.show)"
              :disabled="loading && !(error && error.show)"
              >Simpan</v-btn
            >
          </v-toolbar-items>
        </v-toolbar>
        <v-container>
          <v-tabs v-if="tabHeader.length" v-model="tabs" background-color="transparent" grow centered>
            <v-tab v-for="item in tabHeader" :key="item">
              {{ item }}
            </v-tab>
          </v-tabs>
          <v-alert
            class="mt-7 mb-0"
            prominent
            type="error"
            v-if="(!valid && showError(errors).length) || (error && error.show)"
          >
            <v-row align="center">
              <v-col class="grow">
                <ul v-if="showError(errors) && showError(errors).length">
                  <li v-for="(item, i) in showError(errors)" :key="i">
                    {{ item }}
                  </li>
                </ul>
                <p v-else-if="error && error.desc" v-html="error.desc"></p>
              </v-col>
            </v-row>
          </v-alert>
          <slot></slot>
        </v-container>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>

<script>
import { arrayFlat } from '@utils/format';
import { ValidationObserver } from 'vee-validate';
export default {
  name: 'ModalFull',
  components: { ValidationObserver },
  props: {
    title: {
      type: String,
      default: 'Modal',
    },
    tabHeader: {
      type: Array,
      default: () => [],
    },
    mode: {
      type: String,
      default: 'form',
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      altTitle: null,
      valid: true,
      error: null,
      tabs: 0,
    };
  },
  methods: {
    open(title) {
      this.dialog = true;
      this.loading = false;
      this.error = {};
      if (this.$refs.observer) this.$refs.observer.reset();
      if (title) this.altTitle = title;
    },
    close() {
      this.dialog = false;
      this.loading = false;
    },
    showError(errors) {
      const listError = Object.values(errors).filter((errors) => errors.length);
      return arrayFlat(listError);
    },
    setError(msg) {
      this.error.show = true;
      this.error.desc = msg;
    },
    async save() {
      this.error = {};
      this.valid = await this.$refs.observer.validate();
      if (this.valid) {
        this.loading = true;
        this.$emit('save');
      }
    },
    changeTabs(value) {
      this.$emit('tab', value);
    },
  },
  watch: {
    tabs: 'changeTabs',
  },
};
</script>
